import { LOGIN } from "Constants/ActionTypes";

const actions = {
  getLoginInfoByCode(data) {
    const { host, ...others } = data;
    return {
      type: LOGIN.GET_LOGIN_INFO_BY_CODE,
      payload: {
        request: {
          method: "post",
          url: `${host}/api/v3/login/js`,
          data: others,
        },
      },
    };
  },
  refreshAccessToken(data) {
    return {
      type: LOGIN.REFRESH_ACCESS_TOKEN,
      payload: {
        post: {
          url: "/ticket/api/webchat/refresh/token",
          data,
        },
      },
    };
  },
  // 检查企业是否是定制企业
  checkCustomize() {
    return {
      type: LOGIN.CHECK_CUSTOMISE,
      payload: {
        request: {
          method: "get",
          url: "/robot/customize/check",
        },
      },
    };
  },
  // 获取权限按钮
  setPermissions() {
    return {
      type: LOGIN.BUTTON_PERMISSIONS,
      payload: {
        request: {
          method: "get",
          url: "/robot/application/role/access",
        },
      },
    };
  },
};

export default actions;
